import React, { useEffect, useState } from "react";
import { ReportRenderer } from "./renderer/ReportRenderer";
import { getPdfServerUrl } from "../utils/pdfServer";
import "./styles.css";
import { validateLegacyTemplate } from "./lib/legacyExpressions.mjs";

export default function Printer() {
  const [payload, setPayload] = useState<any>(null);
  const [err, setErr] = useState<any>(null);

  useEffect(() => {
    const controller = new AbortController();
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setErr("Missing token");
      return;
    }

    const pdfServer = getPdfServerUrl();

    // This is the renderer-internal capability endpoint, not the financial REST API.
    fetch(`${pdfServer}/reports/print-payload?token=${encodeURIComponent(token)}`, { signal: controller.signal, cache: "no-store", credentials: "omit", referrerPolicy: "no-referrer" })
      .then(async (r) => {
        if (!r.ok) throw new Error(await r.text());
        return r.json();
      })
      .then((result) => {
        validateLegacyTemplate(result.template);
        if (!controller.signal.aborted) setPayload(result);
      })
      .catch(() => { if (!controller.signal.aborted) setErr("The print snapshot is invalid, expired, or unsupported."); });
    return () => controller.abort();
  }, []);

  return (
    <div
      className="report-root"
      data-ready={payload?.template ? "true" : "false"}
      data-error={err ? "true" : "false"}
    >
      {!payload && !err && (
        <div className="print-status-shell">
          <div className="print-status-card" role="status" aria-live="polite">
            <div className="print-status-spinner" aria-hidden="true" />
            <div>
              <h1>Preparing report</h1>
              <p>Generating the PDF can take a few seconds.</p>
            </div>
          </div>
        </div>
      )}
      {err && (
        <div className="print-status-shell">
          <div className="print-status-card print-status-card--error" role="alert">
            <h1>Print error</h1>
            <p>{err}</p>
          </div>
        </div>
      )}
      {payload?.template && (
        <ReportRenderer template={payload.template} data={payload.data || {}} />
      )}
    </div>
  );
}
